import { faker } from '@faker-js/faker'

import { getPrice } from './Price'

import { HospitalCountry } from '../../contracts/hospital'
import { Currency, ModuleBadge, TargetLanguage, UserRelatedServiceOffer } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getUserRelatedServiceOffer = asBuilder((): UserRelatedServiceOffer => {
  return {
    id: faker.number.int(),
    title: faker.string.uuid(),
    thumbnail: faker.string.uuid(),
    targetLanguage: faker.helpers.enumValue(TargetLanguage),
    badgeList: faker.helpers.arrayElements(Object.values(ModuleBadge), 3),
    rating: {
      totalRating: faker.number.float(),
      ratingCount: faker.number.int(),
    },
    price: {
      currency: faker.helpers.enumValue(Currency),
      originalAmount: faker.number.int(),
      discountedAmount: faker.number.int(),
      discountPercentage: faker.number.int(),
      specialOffer: faker.datatype.boolean(),
      exchangeRateAppliedPrice: getPrice(),
    },
    includeVat: faker.datatype.boolean(),
    hospital: {
      id: faker.number.int(),
      name: faker.string.uuid(),
      district: faker.string.uuid(),
      customerCertified: faker.datatype.boolean(),
      country: faker.helpers.enumValue(HospitalCountry),
    },
    logProperties: {
      amplitude: {},
    },
  }
})
